<script setup lang="ts">
import { computed } from "vue"

const props = withDefaults(
  defineProps<{
    dense?: boolean
    eyebrow?: string
    static?: boolean
    title?: string
    variant?: "dark" | "pale" | "warning" | "danger"
  }>(),
  {
    dense: false,
    static: false,
    variant: "dark"
  }
)

const classes = computed(() => [
  "dashboard-card",
  props.static ? "dashboard-card--static" : "",
  props.variant === "pale" ? "dashboard-card--pale" : "",
  props.variant === "warning" ? "dashboard-card--warning" : "",
  props.variant === "danger" ? "dashboard-card--danger" : ""
])
</script>

<template>
  <section :class="classes">
    <div :class="dense ? 'p-4' : 'p-5'">
      <header v-if="title || eyebrow || $slots.actions" class="mb-5 flex items-start justify-between gap-4">
        <div class="min-w-0">
          <p v-if="eyebrow" class="dashboard-label">{{ eyebrow }}</p>
          <h2 v-if="title" class="mt-2 text-base font-medium leading-tight">
            {{ title }}
          </h2>
        </div>
        <div v-if="$slots.actions" class="shrink-0">
          <slot name="actions" />
        </div>
      </header>

      <slot />

      <footer v-if="$slots.footer" class="mt-5 border-t border-(--dash-line) pt-4">
        <slot name="footer" />
      </footer>
    </div>
  </section>
</template>
